<template>
  <div class="profil">
        <!-- main-area -->
        <main class="fix">
            <!-- about-area -->
            <section class="about__area-five">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-10">
                            <div class="breadcrumb__content">
                                <h2 class="title">Layanan Keuangan Aset & Perencanaan Desa</h2>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="breadcrumb__content">
                                <div class="link-arrow link-arrow-two">
                                    <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#modalFile" title="Lampiran File">
                                        <i class="fas fa-download"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="about__content-five">
                                <div class="about__img-wrap-five">
                                    <!-- <img :src="file_path+file" alt="Apexa" /> -->
                                </div>
                                <p v-html="uraian"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- about-area-end -->
        </main>
        <!-- main-area-end -->
         <div id="modalFile" class="modal fade" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title">{{ judul }}</h6>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <iframe :src="file_path+file" width="100%" height="800px"></iframe>
                </div>
                <div class="modal-footer">
                </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>

export default {
  name: 'Profil',

  data () {
    return {
        file_path: this.$store.state.url.URL_APP + "uploads/",
        unit_kerja: this.$store.state.UNIT_KERJA,
        judul: "",
        uraian: "",
        file: "",
        jenis: "Layanan Keuangan Aset & Perencanaan Desa",
    }
  },

  methods: {
    getView: function() {
        fetch(this.$store.state.url.URL_LAYANAN + "view", {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body : JSON.stringify({
                jenis: this.jenis,
            }),
        })
        .then(res => res.json())
        .then(res_data => {
        this.cek_load_data = false;
        var data = res_data[0];
        this.judul = data.judul;
        this.uraian = data.uraian;
        this.file = data.file;
        });
    },
  },

  mounted () {
    this.getView();
  }
}
</script>
